module.exports = __webpack_public_path__ + "static/media/about-us-banner.46bcc56b.svg";